import React, { useState } from "react";
import { X, Plus, Loader2 } from "lucide-react";
import { domLabel } from "./signalUtil";

export function KeywordGroups({ items, domains, readOnly, onDelete, onAdd, busy }) {
  const [kw, setKw] = useState(""); const [dom, setDom] = useState("");
  const groups = {};
  items.forEach((k) => { const g = k.domain ?? "__null"; (groups[g] = groups[g] || []).push(k); });
  const order = [...domains.map((d) => d.domain).filter((d) => groups[d]), ...Object.keys(groups).filter((g) => g !== "__null" && !domains.some((d) => d.domain === g)), ...(groups.__null ? ["__null"] : [])];
  const submit = async (e) => { e.preventDefault(); if (!kw.trim()) return; if (await onAdd(kw.trim(), dom || null)) setKw(""); };
  return (
    <div data-testid="ts-groups">
      {!readOnly && (
        <form onSubmit={submit} className="mb-4 flex flex-wrap gap-2" data-testid="ts-add-form">
          <input value={kw} onChange={(e) => setKw(e.target.value)} maxLength={60} placeholder="Kata kunci / frasa baru…" className="input-ui min-w-[200px] flex-1 text-xs" data-testid="ts-add-keyword" />
          <select value={dom} onChange={(e) => setDom(e.target.value)} className="input-ui w-auto text-xs" data-testid="ts-add-domain"><option value="">Umum (hanya core_orchestrator)</option>{domains.map((d) => <option key={d.domain} value={d.domain}>{domLabel(d.domain)}</option>)}</select>
          <button type="submit" disabled={busy || !kw.trim()} className="btn-primary rounded-xl px-4 py-2 text-xs" data-testid="ts-add-submit">{busy ? <Loader2 size={13} className="animate-spin" /> : <Plus size={13} />} Tambah</button>
        </form>
      )}
      {!order.length && <p className="rounded-xl border border-dashed border-line p-6 text-center text-xs text-slate-400" data-testid="ts-groups-empty">Belum ada kata kunci untuk bahasa ini.</p>}
      <div className="space-y-4">
        {order.map((g) => (
          <div key={g} data-testid={`ts-group-${g === "__null" ? "null" : g}`}>
            <p className="mb-1.5 text-[11px] font-semibold uppercase tracking-wider text-slate-500">{g === "__null" ? "Umum (hanya core_orchestrator)" : domLabel(g)} <span className="font-mono normal-case text-slate-400">· {groups[g].length}</span></p>
            <div className="flex flex-wrap gap-1.5">
              {groups[g].map((k) => (
                <span key={k.keyword} className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold ${k.builtin ? "bg-slate-100 text-slate-500" : "bg-brand-soft text-brand ring-1 ring-brand/20"}`} title={k.builtin ? "Bawaan — hanya-baca" : "Ditambahkan admin"} data-testid={`ts-chip-${k.keyword}`} data-builtin={k.builtin ? "1" : "0"}>
                  {k.keyword}
                  {!k.builtin && !readOnly && <button type="button" onClick={() => onDelete(k)} className="rounded-full hover:bg-brand/10" aria-label={`Hapus ${k.keyword}`} data-testid={`ts-chip-delete-${k.keyword}`}><X size={11} /></button>}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
